module.exports = __webpack_public_path__ + "static/image/invisible.6ed1bebc9f187e06353f29cdcd474b79.svg";